import { createFeatureSelector, createSelector } from '@ngrx/store'

import { selectedNode } from '@flowx/designer/shared/store/selectors/node.selectors'

import { NodeSlicesState, nodeSlicesFeatureKey } from '../reducers/node-slices.reducer'

export const selectFeature = createFeatureSelector<NodeSlicesState>(nodeSlicesFeatureKey)

export const selectAllNodesSlices = createSelector(selectFeature, (state: NodeSlicesState) => state)

export const selectedNodeSlices = createSelector(
  selectFeature,
  selectedNode,
  (state: NodeSlicesState, selectedNode) => state[selectedNode?.flowxUuid]?.nodeSlices
)
